import { DialogService } from 'aurelia-dialog';
import { inject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import FsUtility from '../../../../Lib/Fs.SmartClient.Client/FsUtility';
import { useView, autoinject, Container } from 'aurelia-framework'
import { EventAggregator } from 'aurelia-event-aggregator';
import { PLATFORM } from 'aurelia-pal';
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import { fromLonLat, transformExtent } from 'ol/proj';
import { OSM, XYZ, TileJSON, Vector as VectorSource } from 'ol/source';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import Point from 'ol/geom/Point';
import { Overlay } from 'ol';
import TabViewModel from '../../../../Lib/Fs.SmartClient.Client/TabViewModel';
import GeoJSON from 'ol/format/GeoJSON';
import PublicAirQualityMapAppService from '../../Scripts/AppServiceContract/PublicAirQualityMapAppService';
import { Fill, Icon, Style, Text, Stroke, Circle } from 'ol/style';
import { toContext } from 'ol/render';
import { fs } from '../../../../Config/FsConfig';
import AirQualityCalculateItemData from '../../Scripts/AppServiceContract/AirQualityCalculateItemData';
import StationAirQualityData from '../../Scripts/AppServiceContract/StationAirQualityData';
declare var Windy: any;

@autoinject()
@useView(PLATFORM.moduleName("./MapMonitoringSearchView.html"))
export default class MapMonitoringSearchVM extends TabViewModel {
  public dialogService: DialogService;
  public i18n: I18N;
  public eventAggregator: EventAggregator;
  changeLocaleSubscribe: any;
  ListDistrict: any;
  ListDistrictFilter: any;
  ListDistrictGroup: any;
  Today: string;
  AirQualityIndexList: any;

  /*Maps*/
  map: any;
  view = new View({
    center: fromLonLat([100.50231745637795, 13.75512316215497]),
    zoom: 10
  });
  public ColorMaps: any;
  chart: any;
  vectorLayer: any;
  LineAreaLayer: any;
  vectorSource: any;

  ShowPopup: boolean;
  DataStation: any;
  AQIData: any;
  StationTime: string;
  StationDate: string;
  AirQualityMax: number;
  AirQualityList: any;
  AirQualityCalculateData: any;
  StationData: any;
  tooltip: any;
  overlay: any;

  public districtGroupId: string;
  airQualityArea: any;
  AttachmentBaseUrl: string;
  get DistrictGroupId(): string {
    return this.districtGroupId
  }
  set DistrictGroupId(data: string) {
    var self = this
    self.districtGroupId = data;

    if (data != null && data != "") {
      self.ListDistrictFilter = self.ListDistrict.filter(t => t.DistrictGroupId == data);
      this.LoadMapLayer(self.AirQualityAreaDatas);
    } else {
      self.ListDistrictFilter = self.ListDistrict;
      this.LoadMapLayer(self.AirQualityAreaDatas);
    }
  }

  public districtId: string;
  get DistrictId(): string {
    return this.districtId
  }
  set DistrictId(data: string) {
    var self = this

    self.districtId = data;
    this.LoadMapLayer(self.AirQualityAreaDatas);

  }

  public AirQualityAreaDatas: any;

  attached() {
    this.LoadMap();
  }

  constructor(i18n: I18N, eventAggregator: EventAggregator) {
    super();
    var self = this;
    self.i18n = i18n;
    self.eventAggregator = eventAggregator;
    let dateTime = new Date();

    self.AttachmentBaseUrl = fs.Config.ServiceBaseUrl + "modules/Aqs.AppService/UploadFileAppService/DownloadFile/id=";
    self.PrepareDropdown().then(() => {
      self.SearchArea();
    });
    //var currentLocale = sessionStorage.getItem("CurrentSystemLocale");

    //th-th
    //en-US
    self.changeLocaleSubscribe = self.eventAggregator.subscribe('ChangeLocale', (response) => {
      var currentLocale = self.i18n.i18next.language == null ? "th-th" : (self.i18n.i18next.language == "th" ? "th-th" : "en-US");

      self.Today = new Intl.DateTimeFormat(currentLocale, { dateStyle: 'full' }).format(dateTime);
      self.PrepareDropdown().then(() => {
        //this.SearchArea();
      });
    });
  }

  SearchArea() {
    var service = this.container.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.Find2()
      .done((result) => {
        this.StationData = result;
        this.FindAirQualityArea();
      }).fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  PrepareDropdown() {
    var defered = $.Deferred();
    var ajax = this.DistrictDropdown();
    var ajax2 = this.DistrictGroupDropdown();
    var ajax3 = this.LoadAirQualityIndexList();

    $.when(ajax, ajax2, ajax3).done(function (r1) {
      defered.resolve(null);
    });

    return defered.promise();
  }

  DistrictDropdown() {
    var self = this;
    var service = Container.instance.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.DistrictDropdown()
      .done((result) => {
        self.ListDistrict = result;
        self.ListDistrictFilter = self.ListDistrict;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  DistrictGroupDropdown() {
    var self = this;
    var service = Container.instance.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.DistrictGroupDropdown()
      .done((result) => {
        self.ListDistrictGroup = result;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  LoadAirQualityIndexList() {
    var self = this;
    var service = Container.instance.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.AirQualityIndexList()
      .done((result) => {
        this.AirQualityIndexList = result;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  FindAirQualityArea() {
    var self = this;
    var service = self.container.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.FindAirQualityArea()
      .done((result) => {
        self.AirQualityAreaDatas = result;
        this.LoadMapLayer(result);
      }).fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  FirstData: any;
  FirstData2: any;
  Test: any;
  Icon: any;
  OpenDailog(stationdata: StationAirQualityData) {
    var self = this;
    var data = [];
    this.ShowPopup = true;
    this.FirstData = stationdata;
    self.FirstData2 = stationdata.AirQualitySelectAvgData;
    if (this.FirstData2) {
      this.Icon = "data:image/png;base64, " + this.FirstData2.AqsIcon;
    }
    
    this.Test = stationdata.AirQualityCalculateItemDatas;
    this.SetData(stationdata.AirQualityCalculateItemDatas);
  }

  SetData(AirQualityCalculateData) {

    if (AirQualityCalculateData != null) {
      if (AirQualityCalculateData.length != 0) {

     
      let dateTime = new Date(AirQualityCalculateData[0].DateTime);
      this.StationTime = new Intl.DateTimeFormat('th-th', { timeStyle: 'short' }).format(dateTime) + " น.";
        this.StationDate = new Intl.DateTimeFormat('th-th', { dateStyle: 'full' }).format(dateTime);
      }
    }
  }

  CloseDailog() {
    this.ShowPopup = false;
    this.StationTime = null;
    this.StationDate = null;
    this.AirQualityCalculateData = null;
  }

  LoadMap() {
    var self = this;
    self.map = new Map({
      view: self.view,
      layers: [
        new TileLayer({
          source: new XYZ({
            url: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
          })
        })
      ],
      target: 'map'
    });
    self.tooltip = document.getElementById('tooltip');
    self.overlay = new Overlay({
      element: self.tooltip,
      offset: [10, 0],
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });
    self.map.addOverlay(self.overlay);
    self.map.on('click', function (evt) {
      var feature = self.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      self.tooltip.style.display = feature ? '' : 'none';


      if (feature) {
        if (feature.values_.Latitude != null) {
          self.overlay.setPosition(evt.coordinate);


          var stationdata = feature.getProperties().data;
          self.OpenDailog(stationdata);
        }

      }



    });

  }

  LoadMapLayer(data) {
    var self = this
    self.airQualityArea = data;
    if (data != null) {
      if (self.DistrictId != null && self.DistrictId != "") {
        data = data.filter(t => t.Id == self.DistrictId);
      }
      self.flyTo(fromLonLat([data[0].LongitudeCenter, data[0].LatitudeCenter]), data[0].Zoom);
      self.addLayerPolygon(data[0].PolygonJSON);
    }

    self.LoadStationOnMap();
  }

  LoadStationOnMap() {
    var self = this;

    if (self.vectorLayer != null) {
      self.map.removeLayer(self.vectorLayer);
    }

    if (self.StationData == null) return;
    var data = self.StationData;

    if (self.DistrictId != null && self.DistrictId != "") {
      data = self.StationData.filter(t => t.DistrictId == self.DistrictId);
    }

    var features = new Array(data.length);
    for (let i = 0; i < data.length; ++i) {

      //var FindMax = Math.max(...data[i].AirQualityCalculateItemDatas.map(o => o.AqsValue));
      //var firstdata = data[i].AirQualityCalculateItemDatas.find(o => o.AqsValue == FindMax);
      //var mainAqi = (firstdata.AqsValue).toString();
      if (data[i].AirQualitySelectAvgData != null) {

        var firstdata = data[i].AirQualitySelectAvgData;
        var mainAqi = (firstdata.AverageAQI).toString();
      } else {
        var firstdata = null;
        var mainAqi = null;
      }

      var icon = '<svg width="100" height = "100" viewBox = "0 0 44 51" fill = "none" xmlns = "http://www.w3.org/2000/svg" ><rect x="0.580078" y = "1.48145" width = "42.8516" height = "42.8516" rx = "4.5"  fill = "' + (firstdata == null ? "#808080" : firstdata.AirQaulityIndexColorCode) + '" stroke = "white" /> <path d="M23.6637 50.1091C22.871 51.286 21.1389 51.286 20.3461 50.1091L16.286 44.0813C15.3911 42.7529 16.343 40.964 17.9448 40.964L26.0651 40.964C27.6668 40.964 28.6187 42.7529 27.7239 44.0813L23.6637 50.1091Z"  fill = "' + (firstdata == null ? "#808080" :firstdata.AirQaulityIndexColorCode )+ '" /> <text x="22" y="25" style="fill:white;" text-anchor="middle"> ' + $.trim(mainAqi) + ' </text> </svg>';

      //var icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20" width="100" height="100"><style>.s0 { fill:' + firstdata.AirQaulityIndexColorCode + '; stroke: #484848 } .s1 { fill: #ffffff } .t0 {font-size:8px; font-family:Cordia New;font-weight: bold; fill:#000000} </style><path id="Layer" class="s0" d="m6.8 18.9c-1-1.1-2.6-3.1-3.9-5.1-0.6-1.1-1.2-2.1-1.7-3.2-0.4-1-0.7-2-0.7-2.8 0-4.1 3.4-7.3 7.5-7.3 4.1 0 7.5 3.2 7.5 7.3 0 0.8-0.3 1.8-0.7 2.8-0.5 1.1-1.1 2.1-1.7 3.2-1.4 2-2.9 4-3.9 5.1-0.6 0.8-1.8 0.8-2.4 0z" /><path id="Layer" class="s1" d="m8 13c-2.8 0-5-2.2-5-5 0-2.8 2.2-5 5-5 2.8 0 5 2.2 5 5 0 2.8-2.2 5-5 5z" /><text x="50%" y="50%" text-anchor="middle" class="t0">' + $.trim(mainAqi) +'</text></svg>';

      features[i] = new Feature({
        geometry: new Point(fromLonLat([data[i].Longitude, data[i].Latitude])),
        data: data[i],
        Latitude: data[i].Latitude,
        Longitude: data[i].Longitude,
        Value: data[i].Value,
      });

      features[i].setStyle(
        new Style({
          image: new Icon({
            opacity: 1,
            src: 'data:image/svg+xml;utf8,' + escape(icon),
            scale: 0.5
          }),
          //text: new Text({
          //  text: $.trim(mainAqi),
          //  font: 'bold 16px Calibri,sans-serif',
          //  fill: new Fill({
          //    color: 'black',
          //  }),
          //  offsetY: -5,
          //}),
        })
      );

    }

    self.vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: features,
      }),

    });

    self.map.addLayer(self.vectorLayer);


  }

  flyTo(location, zoom) {
    var self = this;
    const duration = 2000;

    let parts = 2;
    let called = false;
    function callback(complete) {
      --parts;
      if (called) {
        return;
      }
      if (parts === 0 || !complete) {
        called = true;

      }
    }
    self.view.animate(
      {
        center: location,
        duration: duration,
      },
      callback
    );
    self.view.animate(
      {
        zoom: zoom - 1,
        duration: duration / 2,
      },
      {
        zoom: zoom,
        duration: duration / 2,
      },
      callback
    );
  }

  addLayerPolygon(features) {
    var self = this;
    if (self.LineAreaLayer != null) {

      self.map.removeLayer(self.LineAreaLayer);
    }

    self.LineAreaLayer = new VectorLayer({
      source: new VectorSource({
        url: 'data:,' + encodeURIComponent(features),
        format: new GeoJSON()
      }),
      style: new Style({
        stroke: new Stroke({
          /*color: 'rgb(23,109,248)',*/
          color: 'rgb(0,0,0)',
          width: 2,
        }),

      }),

    });
    self.map.addLayer(self.LineAreaLayer);

  }

}

